import { observer } from 'mobx-react-lite'
import Registration from '~/features/registration'

export const RegistrationPage = observer(() => {
  return <Registration />
})
